import { createGTMEcommerceEvent } from '../../core/ecommerceMapper';
import { DEFAULT_CURRENCY, DEFAULT_QUANTITY, normalizeCommitmentType, normalizeNumber } from '../../core/normalizers';
import { GTMItemServiceType } from '../../types';
import type { GTMEcommerceEvent, GTMEventName, TrackingItem } from '../../types';
import type { PublicOfferEventData, PublicOfferSource } from './types';

const getOfferListName = (planType: string) => planType.toUpperCase();

const mapPublicOfferToTrackingItem = ({
    cartGuid,
    commitment,
    discount,
    index,
    itemCategory,
    itemId,
    name,
    personalOfferId,
    planType,
    price,
    serviceType,
}: PublicOfferSource): TrackingItem => {
    const itemListName = getOfferListName(planType);

    return {
        id: personalOfferId || cartGuid || itemId,
        name,
        brand: itemListName,
        category: itemCategory || itemListName,
        listName: itemListName,
        index,
        variant: commitment ? normalizeCommitmentType(commitment) : undefined,
        price: normalizeNumber(price),
        discount,
        quantity: DEFAULT_QUANTITY,
        currency: DEFAULT_CURRENCY,
        serviceType: serviceType || GTMItemServiceType.NewSale,
    };
};

export const createPublicOfferGAEvent = (event: GTMEventName, { offers }: PublicOfferEventData): GTMEcommerceEvent =>
    createGTMEcommerceEvent(event, {
        itemListName: getOfferListName(offers[0]?.planType || ''),
        items: offers.map(mapPublicOfferToTrackingItem),
    });
